import { useCallback, useEffect, useRef } from 'react';
import { setAssessmentSessionEvent } from '../../services/scoring/scoring.service';
import { ExaminerFunction } from './Assessment.types';
import { AssessmentSessionProcessTypeId } from '../../services/exams/assessmentSession/assessments.types';

interface UseAssessmentWorkTimeProps {
  userFunction: ExaminerFunction | undefined;
  processTypeId: AssessmentSessionProcessTypeId;
}

export const useAssessmentWorkTime = ({ userFunction, processTypeId }: UseAssessmentWorkTimeProps) => {
  const userFunctionRef = useRef(userFunction);
  const processTypeIdRef = useRef(processTypeId);

  const setStartWork = useCallback(() => {
    setAssessmentSessionEvent(1).then(() => sessionStorage.setItem('startWork', 'true'));
  }, []);

  const checkAndExecute = useCallback(
    (forceIfFromAnotherTab = false) => {
      const getItemFromLocalStorage = sessionStorage.getItem('startWork');
      const isItemFromStorage = getItemFromLocalStorage !== 'true';
      const isFunctionE = userFunctionRef.current === ExaminerFunction.CZE;
      const isScoringProcess = processTypeIdRef.current === AssessmentSessionProcessTypeId.Scoring;

      if ((isItemFromStorage || forceIfFromAnotherTab) && isFunctionE && isScoringProcess) {
        setStartWork();
      }
    },
    [setStartWork],
  );

  useEffect(() => {
    let prevUndefined = false;
    if (userFunctionRef.current === undefined) prevUndefined = true;
    userFunctionRef.current = userFunction;
    processTypeIdRef.current = processTypeId;

    if (prevUndefined) checkAndExecute();
  }, [userFunction, processTypeId, checkAndExecute]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkAndExecute(true);
      }
    };

    checkAndExecute();

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [checkAndExecute]);
};
